<template>
  <b-row>
    <b-col>
      <router-link :to="{path: '/popups/login'}" class="mr-4">Login</router-link>
      <router-link :to="{path: '/popups/password-recovery'}" class="mr-4">Password Recovery</router-link>
      <router-link :to="{path: '/popups/subscribe'}" class="mr-4">Subscribe</router-link>
      <router-link :to="{path: '/popups/sign-up'}" class="mr-4">Sign Up</router-link>
      <router-link :to="{path: '/popups/card-registration'}">Card Registration</router-link>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'popups'
  }
</script>